import React, { useState, useEffect } from "react";
import {
  Flex,
  Box,
  Text,
  Image,
  Icon,
  Grid,
  GridItem,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH } from "../../constant";
import dayjs from "dayjs";
import { getBetRecord } from "../../api/getApi";
import { MdClose, MdKeyboardArrowDown } from "react-icons/md";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import NotFound from "../ProgressBlock/NotFound";
import useLongMachineSetting from "../../hook/useLongMachineSetting";

const BetRecordForMachine = ({ onClose }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const i18n_betRecord = (key) => t(`betRecord.${key}`);

  const { images } = useWebsiteInfo();

  const [selectedGame, setSelectedGame] = useState("ALL");
  const [betRecords, setBetRecords] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // 取點擊按鈕前15分鐘的資料
  useEffect(() => {
    const fetchBetRecords = async () => {
      setIsLoading(true);
      try {
        // 計算時間範圍：現在到15分鐘前
        const endTime = dayjs();
        const startTime = endTime.subtract(15, "minute");

        const result = await getBetRecord({
          params: {
            str_date: startTime.toDate(),
            end_date: endTime.toDate(),
          },
        });

        if (result && result.data) {
          setBetRecords(result.data);
        }
      } catch (error) {
        console.error("無法獲取投注記錄:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBetRecords();
  }, []);

  // 把取到的投注記錄轉陣列 並根據選擇的遊戲過濾
  const getFilteredRecords = () => {
    if (Object.keys(betRecords).length === 0) return [];

    // 有下注或有輸贏才顯示(含「無投注但有輸贏」；完全空白的隱藏)
    // Object.entries(betRecords) 會把物件轉成陣列
    const allFilteredRecords = Object.entries(betRecords).filter(
      ([_, value]) => value.totalBet !== 0 || value.totalWinOrLose !== 0,
    );

    if (selectedGame === "ALL") {
      // 如果選擇的是ALL
      return allFilteredRecords; // 顯示所有遊戲
    } else {
      // 如果選擇的是特定遊戲
      return allFilteredRecords.filter(
        ([key, _]) => key === selectedGame, // 根據選擇的遊戲過濾
      );
    }
  };

  const filteredRecords = getFilteredRecords();

  // 遊戲選項
  const gameOptions =
    Object.keys(betRecords).length >= 0
      ? [
          "ALL",
          ...Object.keys(betRecords).filter(
            (key) =>
              betRecords[key].totalBet !== 0 ||
              betRecords[key].totalWinOrLose !== 0,
          ),
        ]
      : ["ALL"];

  // 遊戲選擇
  const handleGameSelect = (game) => {
    setSelectedGame(game);
  };

  // 防止冒泡 點擊內容區域時不關閉彈窗
  const handleContentClick = (e) => {
    e.stopPropagation();
  };
  const { longMachinePaddingTop } = useLongMachineSetting();
  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.8)"
      zIndex="9999"
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
      onClick={onClose}
      pt={longMachinePaddingTop}
    >
      <Box
        onClick={handleContentClick}
        width="100%"
        maxWidth="1000px"
        height="90%"
        position="relative"
      >
        <Flex
          position="absolute"
          right="20px"
          top="20px"
          zIndex="10"
          width="50px"
          height="50px"
          borderRadius="full"
          justifyContent="center"
          alignItems="center"
          cursor="pointer"
          onClick={onClose}
        >
          <Image src={`${COMMON_WEB_PATH}/911TW/closeBetRecord.webp`} />
        </Flex>

        <Flex
          flexDirection="column"
          height="100%"
          padding="40px 30px"
          position="relative"
        >
          {/* 遊戲下拉菜單 */}
          <Box
            position="relative"
            width="100%"
            maxWidth="600px"
            mx="auto"
            mb="30px"
          >
            <Menu placement="bottom" autoSelect={false}>
              <MenuButton
                as={Box}
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                padding="0 20px"
                cursor="pointer"
              >
                <Flex
                  gap={6}
                  justifyContent="center"
                  alignItems="center"
                  position="relative"
                >
                  <Box
                    w={"300px"}
                    height="80px"
                    bgImage={`url('${COMMON_WEB_PATH}/911TW/betRecordSelectBG.webp')`}
                    bgPosition="center"
                    bgRepeat="no-repeat"
                    bgSize="100% 100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    padding="0 20px"
                    cursor="pointer"
                  >
                    <Text
                      color="#fff"
                      fontSize="36px"
                      fontWeight="black"
                      textAlign="center"
                    >
                      {selectedGame}
                    </Text>
                  </Box>
                  <Image
                    src={`${COMMON_WEB_PATH}/911TW/betRecordSelectArrow.webp`}
                    width="20px"
                  />
                </Flex>
              </MenuButton>

              <MenuList
                bgImage={`url('${COMMON_WEB_PATH}/911TW/selectMenuBG.webp')`}
                bgPosition="center"
                bgRepeat="no-repeat"
                bgSize="100% 100%"
                border={"none"}
                bgColor={"transparent"}
                padding="10px"
                py="20px"
                mt={"10px"}
                mr={"20px"}
                maxHeight="400px"
                overflowY="auto"
                w={"350px"}
                css={{
                  // Firefox滾動條樣式
                  scrollbarWidth: "auto",
                  scrollbarColor: "#fdd26a rgba(0,0,0,0.3)",
                }}
                sx={{
                  ".chakra-menu__menuitem": {
                    paddingLeft: "15px",
                    paddingRight: "15px",
                  },
                  "&::-webkit-scrollbar": {
                    width: "15px",
                    display: "block",
                  },
                  "&::-webkit-scrollbar-track": {
                    bg: "rgba(0,0,0,0.3)",
                    borderRadius: "10px",
                    margin: "5px 0",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    bg: "linear-gradient(180deg, #fdd26a 0%, #b07f20 100%)",
                    borderRadius: "10px",
                    border: "3px solid rgba(0,0,0,0.2)",
                    boxShadow: "inset 0 0 5px rgba(255,255,255,0.3)", // 內光暈
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    bg: "linear-gradient(180deg, #ffdf8a 0%, #d19c2a 100%)",
                  },
                }}
              >
                <Box h={"400px"}>
                  {gameOptions.map((game) => (
                    <MenuItem
                      key={game}
                      bgColor="transparent"
                      border="none"
                      onClick={() => handleGameSelect(game)}
                      _hover={{ bg: "#333" }}
                      _focus={{ bg: "#333" }}
                      height="60px"
                      borderBottom="1px solid rgba(253, 210, 106, 0.3)"
                    >
                      <Text
                        width="100%"
                        textAlign="center"
                        color={selectedGame === game ? "#fdd26a" : "white"}
                        fontWeight="black"
                        fontSize="24px"
                      >
                        {game}
                      </Text>
                    </MenuItem>
                  ))}
                </Box>
              </MenuList>
            </Menu>
          </Box>

          <Box
            flex="1"
            overflowY="auto"
            paddingRight="15px"
            css={{
              // Firefox滾動條樣式
              scrollbarWidth: "auto",
              scrollbarColor: "#fdd26a rgba(0,0,0,0.3)",
            }}
            sx={{
              // webkit瀏覽器的滾動條樣式
              "&::-webkit-scrollbar": {
                width: "15px",
                display: "block",
              },
              "&::-webkit-scrollbar-track": {
                bg: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
                margin: "5px 0",
              },
              "&::-webkit-scrollbar-thumb": {
                bg: "linear-gradient(180deg, #fdd26a 0%, #b07f20 100%)",
                borderRadius: "10px",
                border: "3px solid rgba(0,0,0,0.2)",
                boxShadow: "inset 0 0 5px rgba(255,255,255,0.3)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                bg: "linear-gradient(180deg, #ffdf8a 0%, #d19c2a 100%)",
              },

              minHeight: "300px",
              ".chakra-grid": {
                paddingLeft: "15px",
              },
            }}
          >
            {isLoading ? (
              <Flex justifyContent="center" alignItems="center" height="200px">
                <Spinner color="#fdd26a" size="xl" />
              </Flex>
            ) : (
              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  md: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                }}
                gap={6}
                pl="15px"
                pr="10px"
              >
                {filteredRecords.map(([gameCode, data], index) => (
                  <GridItem key={index} colSpan={1}>
                    <Box
                      position="relative"
                      width="100%"
                      height="100%"
                      bgImage={`url('${COMMON_WEB_PATH}/911TW/betRecordInnerBG.webp')`}
                      bgPosition="center"
                      bgRepeat="no-repeat"
                      bgSize="100% 100%"
                      padding="15px"
                    >
                      <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        marginY="10px"
                      >
                        <Text fontSize="30px" fontWeight="bold" color="white">
                          {gameCode}
                        </Text>
                        <Box
                          bg="#4CAF50"
                          color="white"
                          fontSize="14px"
                          padding="2px 10px"
                          borderRadius="20px"
                        >
                          {i18n_betRecord("Settled")}
                        </Box>
                      </Flex>
                      {/* <Text fontSize="16px" color="#fff" textAlign="center">
                        {dayjs().format("YYYY-MM-DD HH:mm:ss")}
                      </Text>

                  
                      <Flex flexDirection="column" justifyContent="flex-start">
                        <Image src={images.orderNumber} h="35px" />
                        <Text
                          fontSize="16px"
                          color="#fff"
                          overflow="hidden"
                          textOverflow="ellipsis"
                        >
                          174460977174460977
                        </Text>
                      </Flex>{" "}
                      */}
                      {/* 投注 */}
                      <Flex flexDirection="column" justifyContent="flex-start">
                        <Image src={images.betTitle1} h="35px" />
                        <Text fontSize="16px" color="white">
                          {data.totalBet.toFixed(2)}
                        </Text>
                      </Flex>
                      {/* 輸贏 */}
                      <Flex
                        flexDirection="column"
                        justifyContent="center"
                        alignItems={"flex-end"}
                      >
                        <Image src={images.winLose} h="35px" w="100%" />
                        <Text
                          mr={"20px"}
                          fontSize="20px"
                          fontWeight="bold"
                          color={
                            data.totalWinOrLose >= 0 ? "#4CAF50" : "#FF5252"
                          }
                        >
                          {data.totalWinOrLose >= 0 ? "+" : ""}
                          {data.totalWinOrLose.toFixed(2)}
                        </Text>
                      </Flex>
                    </Box>
                  </GridItem>
                ))}

                {!isLoading && filteredRecords.length === 0 && (
                  //分成三個 為了讓沒有資料的時候也能置中
                  <>
                    <Box></Box>
                    <NotFound />
                    <Box></Box>
                  </>
                )}
              </Grid>
            )}
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default BetRecordForMachine;
